import {Routes} from '@angular/router';

export const releaseManagementRoutes: Routes = [
  {
    path: 'releaseManagement',
    data: { title: '商品上架管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./release-management.component').then(m => m.ReleaseManagementComponent),
        data: { title: '商品上架管理' },
      },
      {
        path: 'addRelease',
        loadComponent: () => import('./add-release-goods/add-release-goods.component').then(m => m.AddReleaseGoodsComponent),
        data: { title: '添加商品上架' },
      },
      {
        path: 'addRelease/:releaseId',
        loadComponent: () => import('./add-release-goods/add-release-goods.component').then(m => m.AddReleaseGoodsComponent),
        data: { title: '添加商品上架' },
      }
    ]
  },
];
